var minDate = 5;
var maxDate = 8;

if (document.querySelector('.estimated_value_min_delivery_day') && document.querySelector('.estimated_value_min_delivery_day').textContent.trim() !== '') {
  minDate = parseInt(document.querySelector('.estimated_value_min_delivery_day').textContent.trim());
}
if (document.querySelector('.estimated_value_max_delivery_day') && document.querySelector('.estimated_value_max_delivery_day').textContent.trim() !== '') {
  maxDate = parseInt(document.querySelector('.estimated_value_max_delivery_day').textContent.trim());
}

var fromDate = new Date();
fromDate.setDate(fromDate.getDate() + minDate);
while (fromDate.getDay() === 6 || fromDate.getDay() === 0) {
  fromDate.setDate(fromDate.getDate() + 1);
}

var toDate = new Date();
toDate.setDate(toDate.getDate() + maxDate);
while (toDate.getDay() === 6 || toDate.getDay() === 0) {
  toDate.setDate(toDate.getDate() + 1);
}

function formatDate(date) {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var day = date.getDate();
  var monthIndex = date.getMonth();
  var month = (monthIndex + 1).toString().padStart(2, '0');
  return monthNames[monthIndex] + " " + day + "/" + month;
}

document.getElementById('fromDate').innerHTML = formatDate(fromDate);
document.getElementById('toDate').innerHTML = formatDate(toDate);